var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.message)?_c('Card',{staticClass:"ribbon-component mt-2 d-inline-flex py-1",attrs:{"color":_vm.color}},[_c('span',{staticClass:"px-3 overline font-weight-bold"},[_vm._v(_vm._s(_vm.message))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }